import React, { useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import { updateUserPassword } from "../../services/userService";
import { useNotification } from "../../context/NotificationContext";

function UpdatePassword() {
    const { showNotification } = useNotification();
    const [passwordData, setPasswordData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswordData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            showNotification("New passwords do not match", "error");
            return;
        }

        try {
            await updateUserPassword({
                currentPassword: passwordData.currentPassword,
                newPassword: passwordData.newPassword,
            });
            showNotification("Password updated successfully!", "success");
            setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to update password. Please try again.";
            showNotification(errorMessage, "error");
        }
    };

    return (
        <Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                <TextField
                    fullWidth
                    label="Old Password"
                    variant="outlined"
                    type="password"
                    name="currentPassword"
                    value={passwordData.currentPassword}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    label="New Password"
                    variant="outlined"
                    type="password"
                    name="newPassword"
                    value={passwordData.newPassword}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    label="Confirm New Password"
                    variant="outlined"
                    type="password"
                    name="confirmPassword"
                    value={passwordData.confirmPassword}
                    onChange={handleChange}
                />
            </Box>
            <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ marginTop: "2rem", textTransform: "none" }}
                onClick={handleSubmit}
            >
                Update Password
            </Button>
        </Box>
    );
}

export default UpdatePassword;
